
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { ApplicationModule } from "@/store/modules/application";

@Component
export default class AlertBox extends Vue {
  get alert() {
    return ApplicationModule.alert;
  }

  get title() {
    if (ApplicationModule.alert.alertType === "success") {
      return "Success";
    } else if (ApplicationModule.alert.alertType === "error") {
      return "Error";
    } else if (ApplicationModule.alert.alertType === "info") {
      return "Information";
    } else if (ApplicationModule.alert.alertType === "warning") {
      return "Warning";
    } else {
      return "Information";
    }
  }

  get background() {
    if (ApplicationModule.alert.alertType === "success") {
      return "bg-success";
    } else if (ApplicationModule.alert.alertType === "error") {
      return "bg-danger";
    } else if (ApplicationModule.alert.alertType === "info") {
      return "bg-info";
    } else if (ApplicationModule.alert.alertType === "warning") {
      return "bg-warning";
    } else {
      return "bg-info";
    }
  }

  get color() {
    return ApplicationModule.alert.alertType;
  }

  @Watch("alert.alertState")
  onChangeAlertState() {
    if (this.alert.alertState && this.alert.alertType === "success") {
      setTimeout(() => {
        this.dissmissAlert();
      }, 1000);
    }
  }

  dissmissAlert() {
    ApplicationModule.dismissAlert();
  }
}
